
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { showModal } from '../../features/modal/modalSlice';
import { useDispatch } from 'react-redux';
import { getKKKItemData, updateKKK, updateKKKListOrder } from '../../features/adminSett/adminSettSlice';
import textBoldMaker from '../../helper/textBoldMaker';

  const Container = styled.div`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;


        .list-item{
          width: 100%;
          padding: 20px;
          display: flex;
          flex-direction: column;
          border-radius: 20px;
          border: 1px solid ${({theme}) => theme.mainBorderColor};
          color: ${({theme}) => theme.mainTextColor};
          background-color: ${({ theme }) => theme.secondaryBgColor};

          .text-container{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .text-wrapper{
              display: flex;
              align-items: center;

              .text{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-md);

                .bold{
                font-weight: var(--font-weight-xl);
              }
            }

            }
   
 

            .tools{
              display: flex;
              align-items: center;
              gap: 10px;

              .delete-link{
                text-decoration: underline;
                font-weight: var(--font-weight-lg);
                padding: 5px;
                padding-bottom: 2px;
                cursor: pointer;

                &:hover{
                  color: var(--color-red);

                }
              }
              .guncelle-link{
                text-decoration: underline;
                font-weight: var(--font-weight-lg);
                padding: 5px;
                padding-bottom: 2px;
                cursor: pointer;
                
                &:hover{
                  color: var(--color-green);
                }
              }
            }
          }
        }
  `


const VerticalDndKKK = ({data}) => {

    const dispatch = useDispatch()

    const onDragEnd = (result) => {
      if (!result.destination) return; // Sürükleme hedefi yoksa
  
      const reorderedItems = Array.from(data);
      const [movedItem] = reorderedItems.splice(result.source.index, 1); // Öğeyi kaydır
      reorderedItems.splice(result.destination.index, 0, movedItem);
  
      dispatch(updateKKKListOrder(reorderedItems))
      reorderedItems.forEach((item, i) => {
        dispatch(updateKKK({...item, id: parseInt(item.id), termsOrder: parseInt(i)+1}))
      })
    };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId="kkk">
      {(provided) => (
        <Container {...provided.droppableProps} ref={provided.innerRef}>
          {data?.map((item, index) => (
            <Draggable key={item.id} draggableId={item.id} index={index}>
              {(provided) => (
                <div
                 className='list-item'
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  ref={provided.innerRef}
                >
                <div className="text-container">
                  <div className="text-wrapper">{index+1}- <div className="text"  dangerouslySetInnerHTML={{ __html: textBoldMaker(item.terms) }}/></div>
                  <div className="tools">
                    <div className='guncelle-link'onClick={() =>  {dispatch(showModal("updateKKKItem")); dispatch(getKKKItemData(item))}}>Güncelle</div>
                    {/* <div className='guncelle-link'onClick={() =>  {}}>Güncelle</div> */}
                    <div className='delete-link'onClick={() =>  {dispatch(showModal("deleteKKKItem")); dispatch(getKKKItemData(item))}}>Kaldır</div>
                  </div>
                </div>
                </div>
              )}
            </Draggable>
          ))}
        </Container>
      )}
    </Droppable>
  </DragDropContext>
  )
}

export default VerticalDndKKK